<div class="br-modal-header d-flex justify-content-between align-items-center">
  <h1 class="modal-title">Histórico da Confirmação de Vagas</h1>
  <button
    type="button"
    class="br-button circle small"
    aria-label="Fechar"
    title="Fechar"
    (click)="fechar()"
  >
    <i class="fas fa-times" aria-hidden="true"></i>
  </button>
</div>

<div class="br-modal-body">
  <p class="text-muted mb-4">
    Ciclo do Edital <strong>{{ tituloCiclo }}</strong>
    @if (escopoDescricao) {
      · <strong>{{ escopoDescricao }}</strong>
    }
  </p>

  <h2 class="h6 secao-titulo">Comprovantes emitidos</h2>
  @if (carregado && comprovantes.length === 0) {
    <div class="br-message info mb-4">
      <div class="icon"><i class="fas fa-info-circle fa-lg" aria-hidden="true"></i></div>
      <div class="content" role="alert">
        <span class="message-body">Nenhum comprovante emitido para este ciclo.</span>
      </div>
    </div>
  } @else if (comprovantes.length > 0) {
    <div class="table-responsive mb-4">
      <table class="br-table" aria-label="Comprovantes emitidos">
        <thead>
          <tr>
            <th scope="col" class="text-nowrap">Data/hora</th>
            <th scope="col">Comprovante</th>
            <th scope="col">Gestor</th>
            <th scope="col" class="text-center">Ação</th>
          </tr>
        </thead>
        <tbody>
          @for (comprovante of comprovantes; track comprovante.id) {
            <tr>
              <td class="text-nowrap">{{ comprovante.dataEmissao | date: "dd/MM/yyyy HH:mm" }}</td>
              <td>{{ tipoLabel[comprovante.tipo] }}</td>
              <td>{{ comprovante.usuarioNome || "-" }}</td>
              <td class="text-center">
                <i
                  class="fas fa-print action-icon"
                  title="Imprimir comprovante"
                  aria-label="Imprimir comprovante"
                  role="button"
                  tabindex="0"
                  (click)="imprimir(comprovante)"
                  (keydown.enter)="imprimir(comprovante)"
                ></i>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <h2 class="h6 secao-titulo">Alterações</h2>
  @if (carregado && historico.length === 0) {
    <div class="br-message info">
      <div class="icon"><i class="fas fa-info-circle fa-lg" aria-hidden="true"></i></div>
      <div class="content" role="alert">
        <span class="message-body">Nenhuma alteração registrada para este ciclo.</span>
      </div>
    </div>
  } @else if (historico.length > 0) {
    <div class="table-responsive">
      <table class="br-table" aria-label="Alterações da confirmação de vagas">
        <thead>
          <tr>
            <th scope="col" class="text-nowrap">Data/hora</th>
            <th scope="col">Ação</th>
            <th scope="col">O quê</th>
            <th scope="col">Item</th>
            <th scope="col">Campo</th>
            <th scope="col">De</th>
            <th scope="col">Para</th>
            <th scope="col">Usuário</th>
            <th scope="col">IP</th>
          </tr>
        </thead>
        <tbody>
          @for (linha of historico; track linha.id) {
            <tr>
              <td class="text-nowrap">{{ linha.dataAcao | date: "dd/MM/yyyy HH:mm:ss" }}</td>
              <td>{{ acaoLabel[linha.acao] }}</td>
              <td>{{ linha.entidade }}</td>
              <td>{{ linha.registro || "-" }}</td>
              <td>{{ linha.campo || "-" }}</td>
              <td>{{ linha.valorAnterior || "-" }}</td>
              <td>{{ linha.valorNovo || "-" }}</td>
              <td>{{ linha.usuarioNome || "-" }}</td>
              <td class="text-nowrap">{{ linha.ipOrigem || "-" }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>

<div class="br-modal-footer justify-content-end">
  <br-button [emphasis]="'secondary'" (click)="fechar()">Fechar</br-button>
</div>
